import { HttpEvent, HttpEventType, HttpProgressEvent, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { scan } from 'rxjs/operators';
import ObjectID from 'bson-objectid';

export enum UploadState {
    PENDING = 'peinding',
    IN_PROGRESS = 'in-progress',
    DONE = 'done',
}

export interface Upload {
    id: string;
    name?: string;
    progress: number;
    state: UploadState;
    response?: any;
}

function isHttpResponse<T>(event: HttpEvent<T>): event is HttpResponse<T> {
    return event.type === HttpEventType.Response;
}

function isHttpProgressEvent(event: HttpEvent<unknown>): event is HttpProgressEvent {
    return event.type === HttpEventType.DownloadProgress || event.type === HttpEventType.UploadProgress;
}

export function upload(name?: string): (source: Observable<HttpEvent<unknown>>) => Observable<Upload> {
    const id = new ObjectID().toHexString();
    return (source) =>
        source.pipe(
            scan(
                (upload: Upload, event: HttpEvent<unknown>): Upload => {
                    if (isHttpProgressEvent(event)) {
                        return {
                            id,
                            name,
                            progress: event.total ? Math.round((100 * event.loaded) / event.total) : upload.progress,
                            state: UploadState.IN_PROGRESS,
                        };
                    }
                    if (isHttpResponse(event)) {
                        return {
                            id,
                            name,
                            progress: 100,
                            state: UploadState.DONE,
                            response: event.body,
                        };
                    }
                    return upload;
                },
                { id, name, state: UploadState.PENDING, progress: 0 },
            ),
        );
}
